<template>
    <div id="ProgressSearchItem">
        <h2 class="h2 w90-mb" :class="item.status">
            {{ item.products[index].name }}
        </h2>
        <div class="info-wrap w90-mb">
            <aside>
                <div class="status-wrap" :class="item.status">
                    <p>審查情形</p>
                    <h3 v-if="item.status === 'Valid'" class="h2">通過</h3>
                    <h3 v-else-if="item.status === 'Pending'" class="h2">審查中</h3>
                    <h3 v-else class="h2">退件</h3>
                </div>
                <ul v-if="item.status === 'Valid'" class="hide info-list">
                    <li class="list-item">
                        <h4 class="head">環境部資源循環署發文字號</h4>
                        <h5 class="body">{{ item.epaPublishNumber }}</h5>
                    </li>
                    <li class="list-item">
                        <h4 class="head">使用期間</h4>
                        <h5 class="body">{{ item.validDateRange }}</h5>
                    </li>
                </ul>
            </aside>
            <main>
                <div class="info-list-group">
                    <h3 class="h3 hide">申請資訊</h3>
                    <ul class="info-list">
                        <li class="list-item">
                            <h4 class="head">申請產品名稱</h4>
                            <h5 class="body">
                                {{ item.products[index].name }}
                            </h5>
                        </li>
                        <li class="list-item">
                            <h4 class="head">型號</h4>
                            <h5 class="body">
                                {{ item.products[index].model }}
                            </h5>
                        </li>
                        <li class="list-item">
                            <h4 class="head">海廢重量比例</h4>
                            <h5 class="body">{{ item.products[index].weightRate }}%</h5>
                        </li>
                    </ul>
                </div>
                <div class="info-list-group">
                    <h3 class="h3 hide">公司資訊</h3>
                    <ul class="info-list">
                        <li class="list-item">
                            <h4 class="head">申請機構</h4>
                            <h5 class="body">
                                {{ item.registerInstitution }}
                            </h5>
                        </li>
                        <li class="list-item">
                            <h4 class="head">統一編號</h4>
                            <h5 class="body">{{ item.taxId }}</h5>
                        </li>
                        <li class="list-item">
                            <h4 class="head">業者發文文號</h4>
                            <h5 class="body">
                                {{ item.unitPublishNumber }}
                            </h5>
                        </li>
                    </ul>
                </div>
                <div v-if="item.status === 'Valid'" class="hide-mb info-list-group">
                    <ul class="info-list">
                        <li class="list-item">
                            <h4 class="head">環境部資源循環署發文字號</h4>
                            <h5 class="body">
                                {{ item.epaPublishNumber }}
                            </h5>
                        </li>
                        <li class="list-item">
                            <h4 class="head">使用期間</h4>
                            <h5 class="body">{{ item.validDateRange }}</h5>
                        </li>
                    </ul>
                </div>
            </main>
        </div>
    </div>
</template>
<script>
export default {
    name: 'ProgressSearchItem',
    props: { item: Object, index: Number },
}
</script>
<style lang="scss" scoped>
#ProgressSearchItem {
    @media screen and (min-width: 768px) {
        padding: 50px 0;
        border-top: 2px solid $theme0;
        .info-wrap {
            display: flex;
        }
    }
    @media screen and (max-width: 767px) {
        padding: 50px 0 10px;
        margin: 10px 0;
        background-color: $grayF;
    }
}

h2.h2 {
    padding-bottom: 1em;
}
h2.Invalid {
    color: $gray6;
}
aside {
    .status-wrap {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        &.Valid {
            background-color: $theme3;
            p,
            h3 {
                color: $white;
            }
        }
        &.Pending {
            background-color: $theme0;
            p,
            h3 {
                color: $theme3;
            }
        }
        &.Invalid {
            background-color: $grayB;
            p,
            h3 {
                color: $white;
            }
        }
    }

    @media screen and (min-width: 768px) {
        flex: 0;
        .status-wrap {
            width: 160px;
            height: 160px;
        }
    }
    @media screen and (max-width: 767px) {
        display: flex;
        padding-bottom: 20px;
        .status-wrap {
            width: 120px;
            height: 120px;
        }
    }
}
main {
    @media screen and (min-width: 768px) {
        flex: 1;
        display: flex;
    }
}
.info-list-group {
    @media screen and (min-width: 768px) {
        min-width: 18%;
        padding: 0 5%;
        border-right: 1px solid $grayB;
        &:last-child {
            border-right: none;
        }
    }
    @media screen and (max-width: 767px) {
        border-top: 1px solid $grayB;
        padding: 20px 0;
        display: flex;
        h3 {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 120px;
            color: $gray6;
        }
    }
}
.info-list {
    color: $gray6;
    li {
        margin-bottom: 10px;
    }
    @media screen and (min-width: 768px) {
    }
    @media screen and (max-width: 767px) {
        padding: 0 5%;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
}
</style>
